<template>
  <overlay-colored-popup class="light-blue balance-money-popup" :back-action="onBack" :dark-text="true">
    <template>
      <div class="margin-top-medium-large">
        <card v-if="showPakamOption">
          <div class="card-header">פק״מ בבנק ירושלים</div>
          <template v-slot:footer>
            <div class="body-text margin-top-medium">
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>ללא סיכון</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>אפשר למשוך את הכסף בהתראה של חודש</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>
                  <span class="bold">ריבית 4.3%,</span>
                  משתנה בהתאם לריבית הפריים
                </template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text><span class="bold">ללא דמי ניהול</span></template>
              </icon-and-text>
              <riseup-button
                class="margin-top-medium-large margin-bottom-large"
                variant="secondary"
                title="אני רוצה לשמוע עוד"
                :action="pakamClicked"
                size="slim"
                :bold="true"/>
            </div>
          </template>
        </card>
        <card class="margin-top-large">
          <div class="card-header">קרן כספית</div>
          <template v-slot:footer>
            <div class="body-text">
              <div class="margin-top-medium-large margin-bottom-small">
                קרן נאמנות שמושקעת באפיקי השקעה סולידיים, כמו אגרות חוב ופיקדונות.
              </div>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>סיכון נמוך</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>אפשר למשוך את הכסף <span class="bold">בכל יום</span></template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text><span class="bold">דמי ניהול נמוכים</span>, ללא עמלת רכישה</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>הרכישה נעשית דרך הבנק או בית השקעות</template>
              </icon-and-text>
              <riseup-button
                class="margin-top-medium-large margin-bottom-large"
                variant="secondary"
                title="אני רוצה לשמוע עוד"
                :action="moneyFundClicked"
                size="slim"
                :bold="true"/>
            </div>
          </template>
        </card>
        <card class="margin-top-large margin-bottom-medium">
          <div class="card-header">Box ב־PayBox</div>
          <template v-slot:footer>
            <div class="body-text">
              <div class="bold margin-top-medium-large margin-bottom-small">
                לפתוח Box, להעביר את הכסף, ולשלם ישירות ממנו בחנויות נבחרות
              </div>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>סיכון נמוך</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text><span class="bold">הכסף תמיד זמין</span></template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>
                  <span class="bold">ריבית קבועה של 2.5%</span><!--
                  --><span>, ללקוחות כרטיס האשראי הדיגיטלי של פייבוקס.</span>
                </template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>בשימוש מעל 2,000 ₪ בחודש בכרטיס הריבית עולה ל-5%</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>הצבירה מוגבלת עד 20,000 ₪</template>
              </icon-and-text>
              <icon-and-text v-bind="iconAndTextProps">
                <template v-slot:text>אין דמי ניהול</template>
              </icon-and-text>
              <riseup-button
                class="margin-top-medium-large margin-bottom-large"
                variant="secondary"
                title="אני רוצה לשמוע עוד"
                :action="boxClicked"
                size="slim"
                :bold="true"/>
            </div>
          </template>
        </card>
      </div>
    </template>
    <template v-slot:footer v-if="!hideSnooze">
      <div class="centered">
        <a class="link-button" @click="remindMeLaterClicked">
          מעניין, תזכירו לי אח"כ
        </a>
      </div>
    </template>
  </overlay-colored-popup>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';

export default {
  name: 'BalanceMoneyStep3',
  components: {
    OverlayColoredPopup: BaseUI.OverlayColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
    IconAndText: BaseUI.IconAndText,
    Card: BaseUI.Card,
  },
  props: {
    onBack: {
      type: Function,
      required: true,
    },
    onMoneyFundClicked: {
      type: Function,
      required: true,
    },
    onPakamClicked: {
      type: Function,
      required: true,
    },
    onBoxClicked: {
      type: Function,
      required: true,
    },
    onDismiss: {
      type: Function,
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
    hideSnooze: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      iconAndTextProps: {
        iconSize: '16px',
        fillIcon: true,
        class: 'balance-money-icon-and-text',
        iconFontName: 'check_circle',
        iconColor: BaseUI.Colors.riseupBlue,
      },
    };
  },
  created() {
    Segment.trackUserInteraction('BalanceMoneyFlow_StepEntered', { step: this.stepName });
  },
  computed: {
    showPakamOption() {
      // The interest rate has changed and until we reach a new agreement with the bank, we hide this option
      return false;
    },
  },
  methods: {
    moneyFundClicked() {
      Segment.trackUserInteraction('BalanceMoneyFlow_ClickedMoneyFund');
      this.onMoneyFundClicked();
    },
    pakamClicked() {
      Segment.trackUserInteraction('BalanceMoneyFlow_ClickedPakam');
      this.onPakamClicked();
    },
    boxClicked() {
      Segment.trackUserInteraction('BalanceMoneyFlow_ClickedBox');
      this.onBoxClicked();
    },
    remindMeLaterClicked() {
      this.onDismiss(true);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/personalized-savings/balance-money/balance-money-styles";

</style>
